export default "__VITE_ASSET__DeGs9HiO__"